import { render, staticRenderFns } from "./inloggen.vue?vue&type=template&id=210c3a8e&"
import script from "./inloggen.vue?vue&type=script&lang=js&"
export * from "./inloggen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/base/Loader.vue').default})
